export const downloadLink = "«DownloadLink»";
